export const downloadLink = "«DownloadLink»";
